import { render, staticRenderFns } from "./overlay-drawer-image.vue?vue&type=template&id=0515f788"
import script from "./overlay-drawer-image.vue?vue&type=script&lang=js"
export * from "./overlay-drawer-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports